import { CommunityMap } from "openchat-shared";
import { writable } from "../../utils/stores";
import { notEq } from "../utils";
export class CommunitySummaryUpdates {
    displayName = undefined;
    rulesAccepted;
    index;
}
export const communitySummaryLocalUpdates = writable(new CommunityMap(), undefined, notEq);
